import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { agreementLinksManager } from '@inpart-io/padme-iap';
import { type IAgreementLink } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

const AGREEMENT_LINK_MODULE = 'agreementLink';

const dataObjectModule = getDataObjectsModule<IAgreementLink>(agreementLinksManager);
const searchModule = getSearchModule<IAgreementLink>(agreementLinksManager);

const agreementLinkModuleInstance = merge<unknown>(dataObjectModule, searchModule);
store.registerModule(AGREEMENT_LINK_MODULE, agreementLinkModuleInstance);

export { AGREEMENT_LINK_MODULE };
